// Additional API functions for Vendor Dashboard, Likes, Comments, Orders
import client from "@/lib/api";

// Vendor
export const vendorShops = () => client.get("/vendor/shops").then((r) => r.data);
export const vendorGetShop = (shop_id) => client.get(`/vendor/shops/${shop_id}`).then((r) => r.data);
export const vendorUpdateShop = (shop_id, patch) => client.patch(`/vendor/shops/${shop_id}`, patch).then((r) => r.data);
export const vendorUpdateBusinessProfile = (shop_id, body) => client.patch(`/vendor/shops/${shop_id}/business-profile`, body).then((r) => r.data);
export const vendorUpdateStatus = (shop_id, status_mode) => client.post(`/vendor/shops/${shop_id}/status`, { status_mode }).then((r) => r.data);
export const vendorShopVisibility = (shop_id, listed) => client.post(`/vendor/shops/${shop_id}/visibility`, { listed }).then((r) => r.data);
export const vendorUpdateHours = (shop_id, hours) => client.post(`/vendor/shops/${shop_id}/business-hours`, { hours }).then((r) => r.data);
export const vendorProducts = () => client.get("/vendor/products").then((r) => r.data);
export const vendorCreateProduct = (payload) => client.post("/vendor/products", payload).then((r) => r.data);
export const vendorUpdateProduct = (id, payload) => client.patch(`/vendor/products/${id}`, payload).then((r) => r.data);
export const vendorToggleProductStock = (id, in_stock) => client.patch(`/vendor/products/${id}/stock`, { in_stock }).then((r) => r.data);
export const vendorSetStock = (id, body) => client.patch(`/vendor/products/${id}/stock`, body).then((r) => r.data);
export const vendorDeleteProduct = (id) => client.delete(`/vendor/products/${id}`).then((r) => r.data);

// Vendor services
export const vendorServices = () => client.get("/vendor/services").then((r) => r.data);
export const vendorCreateService = (payload) => client.post("/vendor/services", payload).then((r) => r.data);
export const vendorUpdateService = (id, payload) => client.patch(`/vendor/services/${id}`, payload).then((r) => r.data);
export const vendorToggleService = (id, active) => client.post(`/vendor/services/${id}/toggle`, { active }).then((r) => r.data);
export const vendorServiceAvailability = (id, available, availableFrom = null) => client.post(`/vendor/services/${id}/availability`, { available, available_from: availableFrom }).then((r) => r.data);
export const vendorDeleteService = (id) => client.delete(`/vendor/services/${id}`).then((r) => r.data);

// Vendor analytics
export const vendorToolbagSummary = (shop_id) => client.get("/vendor/toolbag-summary", { params: { shop_id } }).then((r) => r.data);
export const vendorOrderAlerts = () => client.get("/vendor/order-alerts").then((r) => r.data);
export const vendorOrderAlertsSeen = () => client.post("/vendor/order-alerts/seen").then((r) => r.data);
export const vendorAnalytics = () => client.get("/vendor/analytics").then((r) => r.data);

// Vendor orders
export const vendorOrders = (params = {}) => client.get("/vendor/orders", { params }).then((r) => r.data);
export const vendorOrderDetail = (id) => client.get(`/vendor/orders/${id}`).then((r) => r.data);
export const vendorUpdateOrderStatus = (id, status, reason) => client.post(`/vendor/orders/${id}/status`, { status, reason }).then((r) => r.data);

// Customer orders
export const createOrder = (payload) => client.post("/orders", payload).then((r) => r.data);
export const myOrders = () => client.get("/orders").then((r) => r.data);
export const myOrderDetail = (id) => client.get(`/orders/${id}`).then((r) => r.data);
export const cancelMyOrder = (id, reason) => client.post(`/orders/${id}/cancel`, { reason }).then((r) => r.data);

// Admin
export const adminVendorApps = () => client.get("/admin/vendor-applications").then((r) => r.data);
export const adminApprove = (app_id) => client.post(`/admin/vendor-applications/${app_id}/approve`).then((r) => r.data);

// Likes & Comments
export const likeProduct = (id) => client.post(`/products/${id}/like`).then((r) => r.data);
export const unlikeProduct = (id) => client.delete(`/products/${id}/like`).then((r) => r.data);
export const listComments = (id) => client.get(`/products/${id}/comments`).then((r) => r.data);
export const addComment = (id, comment) => client.post(`/products/${id}/comments`, { comment }).then((r) => r.data);
